import { LogErrors } from './../LogErrors'


//const URLBase = 'https://api.riactivos.com/Api/V2/'
const URLBase = process.env.REACT_APP_API_URL //'https://riactivos.xyz/Api/V2/'


/**
 * 
 * @param {string} accessCode
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const CheckAccessCode = async (accessCode) => {
    try {
        const dataToSend = {
            accesscode: accessCode
        }
        
        const response = await fetch(URLBase + "Common/CheckAccessCode", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 401) {
                const errorData = await response.json()
                return { success: false, message: errorData.message || 'El código de acceso que ingresaste no es válido. Ingresa uno válido.' }
            } else {
                return { success: false, message: 'No ha sido posible validar el código de acceso que ingresaste. Inténtalo nuevamente o inténtalo más tarde.' }
            }
            
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data }
    } catch (error) {
        //console.error('Error en Login DL:', error);
        //return { success: false, message: error || 'Error al conectar con el servidor' }
        await LogErrors('CheckAccessCode - Sessions DL', error)
        //return { success: false, message: 'errorNetwork' } // Código genérico para errores de red
        return { success: false, message: 'No ha sido posible validar el código de acceso que escribiste. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

/**
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const GetSignUpInfo = async () => {
    try {
        if (sessionStorage.getItem('ioerjgiafung')) {
            const response = await JSON.parse(sessionStorage.getItem('ioerjgiafung'))

            if (response.name === undefined || response.name === '') {
                return { success: false, data: 'Hubo un error al intentar mostrar la información' }
            }

            return { success: true, data: response }
        } else {
            return { success: false, data: 'Hubo un error al intentar mostrar la información' }
        }
    } catch (error) {
        await LogErrors('GetSignUpInfo - Session DL', error)
        return { success: false, message: '' }
    }
}

/**
 * @param {Array} dataToSave
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const SaveSignUpInfo = async (dataToSave) => {
    try {
        await sessionStorage.setItem('ioerjgiafung', JSON.stringify(dataToSave))

        return { success: true, data: {} }
    } catch (error) {
        await LogErrors('SaveSignUpInfo - Session DL', error)
        return { success: false, message: '' }
    }
}

const DeleteSignUpInfo = async () => {
    try {
        await sessionStorage.removeItem('ioerjgiafung')

        return { sucess: true, data: {} }
    } catch (error) {
        await LogErrors('DeleteSignUpInfo - Session DL', error)
        return { success: false, message: '' }
    }
}

export { CheckAccessCode, GetSignUpInfo, SaveSignUpInfo, DeleteSignUpInfo };